<!-- Dialog title based on the presence of table data -->
<div>
  <h3 mat-dialog-title class="bg-white customization-head">
    @if (this.data.station) {
      Update {{ this.data.station.station_name }}
    } @else {
      Add New Station
    }
  </h3>

  <div class="sub-head pl-4">Create stations to later connect printers to each station.</div>

  <!-- Form starts here -->
  <form [formGroup]="stationForm">
    <mat-dialog-content class="pt-2 pb-1">
      <div class="d-flex flex-column mb-3 pt-2">
        <!-- Type Input Section -->
        <div class="row">
          <div>
            <label class="form-label pl-0"> <span class="status-span">*</span>Name: </label>
          </div>
          <div class="mt-1">
            <input
              type="text"
              class="form-control"
              placeholder="Eg: Station 1"
              (input)="filterStation()"
              formControlName="station_name"
              [ngClass]="{
                'input-error':
                  (stationForm.get('station_name')?.invalid &&
                    (stationForm.get('station_name')?.dirty ||
                      stationForm.get('station_name')?.touched)) ||
                  isDuplicate,
              }"
            />
            <!-- Error for empty type -->
            @if (
              stationForm.get('station_name')?.errors?.['required'] &&
              (stationForm.get('station_name')?.dirty || stationForm.get('station_name')?.touched)
            ) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Station name cannot be empty.</p>
              </div>
            }
            @if (stationForm.get('station_name')?.errors?.['minlength']) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Station Name must be at least 3 characters long.</p>
              </div>
            }
            @if (stationForm.get('station_name')?.errors?.['maxlength']) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Station Name can not exceed 50 characters.</p>
              </div>
            }
            <!-- Error for existing type -->
            @if (isDuplicate) {
              <div class="d-flex mt-2 errorText gap-2">
                <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
                <p>Station name already exists in the system.</p>
              </div>
            }
          </div>
        </div>

        <div class="row mt-3">
          <div>
            <label class="form-label pl-0"> <span class="status-span">*</span>Type: </label>
          </div>
          <div class="mt-1">
            <button
              class="btn dropdown-toggle bg-white form-control border text-left rounded-2"
              type="button"
              id="dropdownMenuButton2"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ selectedType ? (selectedType | titlecase) : 'Select Type' }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
              @for (station of stationTypes; track station; let i = $index) {
                <li (click)="changeStationType(station)">
                  <a class="dropdown-item">{{ station.displayName | titlecase }}</a>
                </li>
              }
            </ul>
          </div>
        </div>
        @if (!data.isFromMenu) {
          <!-- Checkbox Section -->
          <div class="row mt-3">
            <div class="col-12">
              <div class="d-flex">
                <div class="">
                  <input
                    class="form-check-input ml-0"
                    type="checkbox"
                    formControlName="is_default"
                    (change)="onDefaultChange($event)"
                  />
                </div>
                <div class="ml-4">
                  <label class="form-label pl-0"> Default Station: </label>
                </div>
              </div>
            </div>
            @if (displayDuplicateError) {
              <div class="d-flex mt-1 text-warning gap-2">
                <p>
                  This station type already has a default station. Adding a new station will set it
                  as the default and remove the previous one.
                </p>
              </div>
            }
          </div>
        }
      </div>
      <div class="custom-line-top mt-1"></div>
    </mat-dialog-content>

    <!-- Actions -->
    <mat-dialog-actions class="justify-content-end gap-3 pt-3 pb-3 pr-4">
      <button
        class="btn btn-white border rounded-3 text-black-50 w-25 common-add-btn bg-white"
        mat-dialog-close
      >
        Cancel
      </button>
      @if (this.data.station) {
        <!-- Update button -->
        <button
          type="button"
          class="btn btn-dark rounded-3 common-add-btn"
          [disabled]="stationForm.invalid || isDuplicate"
          (click)="addNewStation()"
        >
          Update
        </button>
      } @else {
        <!-- Add New Station button -->
        <button
          type="button"
          class="btn btn-dark rounded-3 common-add-btn"
          [disabled]="stationForm.invalid || isDuplicate"
          (click)="addNewStation()"
        >
          Add New Station
        </button>
      }
    </mat-dialog-actions>
  </form>
</div>
